import React from "react";
import withMotion from "../../../../Utils/withMotion";
import Sidebar from "../../Sidebar/Sidebar";
import "../../Blog.scss";

//Utils
import { mapBlogs } from "../../Pagination/utils";

//Images
import banner from "../../images/porcelainPavers/porcelain-pavers-banner.jpg";
import composite from "../../images/porcelainPavers/porcelain-pavers-composite.jpg";
import indoor from "../../images/porcelainPavers/porcelain-pavers-indoor-outdoor.jpg";
import patio from "../../images/porcelainPavers/porcelain-pavers-patio.jpg";
import pool from "../../images/porcelainPavers/porcelain-pavers-pool-deck.jpg";

// SEO
import SEO from "../../../../SEO/index.js";
import StructuredData from "../../../../SEO/structuredData";
import { ViewPavers } from "../../../../CTA/CTA";

export const PorcelainPaversData = {
  title: "Porcelain Pavers: Beauty, Durability and Ease of Maintenance",
  image: banner,
  destination: "/blog/porcelain-pavers-beauty-durability-ease-maintenance",
  date: "January 9, 2017",
  categories: [
    "blog",
    "choosing-a-paving-material",
    "patios",
    "paving-stones",
    "walkways",
  ],
};

const PorcelainPavers = () => {
  const blog = [PorcelainPaversData];

  return (
    <>
      <SEO
        title="Outdoor Porcelain Pavers - Cost, Benefits & How to Install"
        description="Learn the benefits of outdoor porcelain pavers including the cost, durability, and ease of maintenance. Also, learn how to install!"
        profileURL={
          "https://www.pacificpavingstone.com/blog/porcelain-pavers-beauty-durability-ease-maintenance"
        }
      />
      <StructuredData
        orgaCreator={{
          "@context": "https://schema.org/",
          "@type": "BlogPosting",
          author: {
            "@type": "Organization",
            name: "Pacific Pavingstone",
          },
          URL: "https://www.pacificpavingstone.com/blog/porcelain-pavers-beauty-durability-ease-maintenance",
          headline:
            "Outdoor Porcelain Pavers - Cost, Benefits & How to Install",
          description:
            "Learn the benefits of outdoor porcelain pavers including the cost, durability, and ease of maintenance. Also, learn how to install! ",
          image: {
            "@type": "ImageObject",
            url: "https://www.pacificpavingstone.com/static/media/porcelain-pavers-banner.6697eb8f.jpg",
          },
          datePublished: "2017-01-09",
          publisher: {
            "@type": "Organization",
            name: "Pacific Pavingstone",
          },
        }}
      />
      <div className="container-fluid page-blog">
        <div className="row justify-content-center">
          <div className="col-11 col-lg-6">
            {mapBlogs(1, blog, true)}
            <h4>A WIDE RANGE OF BEAUTIFUL LOOKS AT ECONOMICAL PRICE</h4>
            <p>
              Manufacturers like MSI and Mirage (carried by Belgard, among
              others) produce a wide range of porcelain paver looks and finishes
              to beautify any home or yard. Designed in Italy, but produced in
              the USA, they are as attractive as they are cost-effective when
              compared to natural stone such as travertine or slate. These are
              three examples, snapped almost at random in MSI’s Sun Valley
              showroom.
            </p>
            <img src={composite} alt="Composite" />
            <h4>LOWER COST OF MAINTENANCE</h4>
            <p>
              Porcelain pavers are impervious to oil, water, and chemical
              spills, so you never have to worry about stains, as you do with
              concrete, stone or wood. They also don’t crack, dry out, rot or
              suffer from mold.
              <br />
              <br />
              The glazed finish is incredibly durable, so unless you routinely
              run herds of buffalo through your backyard you won’t have to
              repaint or retouch the finish the way you must with painted
              concrete or wood surfaces. It also never fades or discolors, even
              in the most intense sun exposure. Porcelain pavers don’t require
              sealers, resins or glues, making them almost the ultimate in
              environmentally-friendly outdoor finishes.
              <br />
              <br />
              These modern finishes are inherently non-skid, even when wet, so
              that they don’t require periodic treatment to keep them safe to
              walk on—an important consideration for a pool deck or raised
              patio.
            </p>
            <h4>MORE DURABLE THAN WOOD OR NATURAL STONE</h4>
            <p>
              The texturing and glazing techniques used in the manufacture of
              porcelain pavers let you create a perfect wooden or natural stone
              look for your walkways, patio or deck without the expense or
              maintenance headaches that these traditional materials require.
              With wood finish porcelain tiles, for example, you gain the
              perfect look of a wood deck without ever having to worry about
              termites. And it goes without saying that porcelain pavers are
              fireproof, so if your home is anywhere near potential wildfires,
              your deck or patio will be safe from burning.
            </p>
            <img src={pool} alt="Pool" />
            <p>
              Porcelain pavers are impervious to water, so you gain the beauty
              of a natural look without the problems of weathering, stains or
              water absorption. (If you live in an area subject to occasional
              freezing, water absorption becomes an especially big deal. Water
              expands as it freezes, and can easily crack natural stone.)
              <br />
              <br />
              Durability and wear resistance make porcelain pavers ideal, making
              them suitable even for high foot traffic commercial applications
              such as parks or commercial building forecourts. We don’t
              recommend them, however, for driveways or other situations where
              the pavers must carry very heavy loads; in that situation they
              must be mortar-set, which quickly becomes cost-prohibitive.
            </p>
            <img src={patio} alt="Patio" />
            <p>
              Porcelain pavers and interior tiles frequently come in matching
              finishes, allowing the homeowner, designer or architect to
              continue an inside finish right out to the yard, like this
              example:
            </p>
            <img src={indoor} alt="Indoor Outdoor" />
            <h4>INSTALLING PORCELAIN PAVERS</h4>
            <p>
              Porcelain pavers can be installed in several ways, including a
              traditional (and very expensive, in exterior installations) mortar
              bed. Our method of choice for hardscaping and decks in Southern
              California is to set them in sand, using sand joints between the
              pavers. This allows a slight amount of flexibility that insures
              against cracking or damage due to earth movements. A final
              installed cost starts at around $20 per square foot.
            </p>
            <h4>THE “HEAT ISLAND EFFECT”</h4>
            <p>
              California in summer is nothing if not hot, and the amount of heat
              that a surface absorbs and then radiates back into your
              environment makes a big difference to how comfortable it feels.
              Your pool deck or patio might not get hot enough to fry an egg,
              but a stone or concrete surface baking in the afternoon sun easily
              gets hot enough that your kids (and you!) don’t want to walk on it
              barefoot. It also bathes your home in unwanted heat that increases
              your air conditioning bill and can make your yard unlivable on hot
              days.
              <br />
              <br />
              The technical name for this is the “heat island effect,” and it’s
              just what the name implies: an island of extra warmth in the
              immediate surroundings of your home. The hotter your yard surface
              gets, the greater the heat island. What’s called the “Solar
              Reflection Index” (SRI) is a number that tells you how well, or
              how poorly, a surface resists being heated up. A black asphalt
              surface has an SRI of about 0 (which could reach a temperature
              rise of as much as 90 degrees or more in full sunlight), whereas
              one painted with bright white reflective paint might rise as
              little as 15 degrees.
              <br />
              <br />
              How well or poorly the material absorbs heat also factors into
              this, and it turns out that porcelain has tremendous heat
              resistance. It warms up very little in comparison to either
              concrete, manufactured stone, or natural stone of the same shade.
              With an SRI of 60–80, porcelain pavers reduce the heat island
              effect more than enough to qualify for LEED credits in new
              construction and keep your home environment a lot more
              comfortable!
            </p>
            <h4>BOTTOM LINE: YOU HAVE MORE CHOICES</h4>
            <p>
              When it comes to improving your home’s value with new hardscaping,
              walkways or decks, you now have a far wider range of choices than
              were available only a few years ago. Our designers are excited by
              the new, cost-effective and environmentally friendly options they
              can offer, and will be happy to show you how porcelain pavers can
              enhance the look of your home.
            </p>
            <ViewPavers/>
          </div>
          <Sidebar />
        </div>
      </div>
    </>
  );
};

export default withMotion(PorcelainPavers);
